import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import {
  IOrderLabelingDetail,
  IUpdateOrderLabelingRequest,
  IFindOrderLabelingRequest,
  IFindAllFinishedOrderRequest,
} from "../orderLabelingModel";

// Find all finished orders (isfinishorder = true)
export const findAllFinishedOrder = createAsyncThunk(
  "OrderLabeling/FindAllOrderisfinishorderTrue",
  async (request: IFindAllFinishedOrderRequest = {}) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Order/FindAllOrderisfinishorderTrue`,
        request,
      );
      const data = response.data?.Data || [];
      const totalCount = response.data?.TotalCount || data.length;

      const formattedData = data.map((item: any) => ({
        ...item,
        order_date: item.order_date,
        delivery_date: item.delivery_date,
        ORDERLabeling: item.ORDERLabeling || [],
      }));

      return {
        Data: formattedData,
        TotalCount: totalCount,
      };
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching finished orders:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Find order labeling by ID for editing
export const findOrderLabelingById = createAsyncThunk(
  "OrderLabeling/FindbyIDOrderLabeling",
  async (request: IFindOrderLabelingRequest) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Order/FindbyIDOrderLabeling`,
        request,
      );
      const result = response.data?.Data as IOrderLabelingDetail;

      if (result) {
        result.GrossWeight = result.GrossWeight || 0;
        result.LessWeight = result.LessWeight || 0;
        result.NetWeight = result.NetWeight || 0;
        result.ORDERLabeling =
          result.ORDERLabeling?.length > 0
            ? result.ORDERLabeling?.reduce((acc: any[], item: any) => {
                const finditem = acc.find(
                  (aci: any) => aci.ItemID === item.ItemID,
                );
                if (finditem) {
                  finditem.Weight = Number(
                    ((finditem.Weight || 0) + (item.Weight || 0)).toFixed(3),
                  );
                  finditem.Pcs = (finditem.Pcs || 0) + (item.Pcs || 0);
                  if (finditem.Total !== undefined || item.Total !== undefined) {
                    finditem.Total = (finditem.Total || 0) + (item.Total || 0);
                  }
                  if (finditem.total !== undefined || item.total !== undefined) {
                    finditem.total = (finditem.total || 0) + (item.total || 0);
                  }
                } else {
                  acc.push({
                    ...item,
                    id: item.id || item.item_id || item.ItemID,
                  });
                }
                return acc;
              }, [])
            : [];
      }

      return result;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching order labeling:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Find order labeling by ID for view only
export const findOrderLabelingViewById = createAsyncThunk(
  "OrderLabeling/FindbyIDOrderLabelingView",
  async (request: IFindOrderLabelingRequest) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Order/FindbyIDOrderLabelingView`,
        request,
      );
      const result = response.data?.Data as IOrderLabelingDetail;

      if (result) {
        result.GrossWeight = result.GrossWeight || 0;
        result.LessWeight = result.LessWeight || 0;
        result.NetWeight = result.NetWeight || 0;
        result.ORDERLabeling =
          result.ORDERLabeling?.length > 0
            ? result.ORDERLabeling?.reduce((acc: any[], item: any) => {
                const finditem = acc.find(
                  (aci: any) => aci.ItemID === item.ItemID,
                );
                if (finditem) {
                  finditem.Weight = Number(
                    ((finditem.Weight || 0) + (item.Weight || 0)).toFixed(3),
                  );
                  finditem.Pcs = (finditem.Pcs || 0) + (item.Pcs || 0);
                  if (finditem.Total !== undefined || item.Total !== undefined) {
                    finditem.Total = (finditem.Total || 0) + (item.Total || 0);
                  }
                  if (finditem.total !== undefined || item.total !== undefined) {
                    finditem.total = (finditem.total || 0) + (item.total || 0);
                  }
                } else {
                  acc.push({
                    ...item,
                    id: item.id || item.item_id || item.ItemID,
                  });
                }
                return acc;
              }, [])
            : [];
      }

      return result;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching order labeling view:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// Update order labeling
export const updateOrderLabeling = createAsyncThunk(
  "OrderLabeling/UpdateOrderLabeling",
  async (request: IUpdateOrderLabelingRequest) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Order/UpdateOrderLabeling`,
        request,
      );
      SuccessToast(
        response.data?.Details || "Order labeling updated successfully",
      );
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating order labeling:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
